// Comprehensive list of dial codes for the PhoneInput component.
// Default country = Saudi Arabia (+966). Ordered: GCC & MENA first, then alphabetical.
export const PHONE_COUNTRIES = [
  // GCC / MENA — most likely customers (per business focus)
  { code: "SA", flag: "🇸🇦", name: "Saudi Arabia",       dial: "+966" },
  { code: "AE", flag: "🇦🇪", name: "United Arab Emirates",dial: "+971" },
  { code: "KW", flag: "🇰🇼", name: "Kuwait",              dial: "+965" },
  { code: "QA", flag: "🇶🇦", name: "Qatar",               dial: "+974" },
  { code: "BH", flag: "🇧🇭", name: "Bahrain",             dial: "+973" },
  { code: "OM", flag: "🇴🇲", name: "Oman",                dial: "+968" },
  { code: "JO", flag: "🇯🇴", name: "Jordan",              dial: "+962" },
  { code: "LB", flag: "🇱🇧", name: "Lebanon",             dial: "+961" },
  { code: "EG", flag: "🇪🇬", name: "Egypt",               dial: "+20"  },
  { code: "TR", flag: "🇹🇷", name: "Türkiye",             dial: "+90"  },
  { code: "MA", flag: "🇲🇦", name: "Morocco",             dial: "+212" },
  { code: "TN", flag: "🇹🇳", name: "Tunisia",             dial: "+216" },
  { code: "DZ", flag: "🇩🇿", name: "Algeria",             dial: "+213" },
  { code: "IQ", flag: "🇮🇶", name: "Iraq",                dial: "+964" },
  { code: "YE", flag: "🇾🇪", name: "Yemen",               dial: "+967" },
  // Schengen + popular European
  { code: "DE", flag: "🇩🇪", name: "Germany",             dial: "+49"  },
  { code: "FR", flag: "🇫🇷", name: "France",              dial: "+33"  },
  { code: "IT", flag: "🇮🇹", name: "Italy",               dial: "+39"  },
  { code: "ES", flag: "🇪🇸", name: "Spain",               dial: "+34"  },
  { code: "NL", flag: "🇳🇱", name: "Netherlands",         dial: "+31"  },
  { code: "BE", flag: "🇧🇪", name: "Belgium",             dial: "+32"  },
  { code: "AT", flag: "🇦🇹", name: "Austria",             dial: "+43"  },
  { code: "CH", flag: "🇨🇭", name: "Switzerland",         dial: "+41"  },
  { code: "PT", flag: "🇵🇹", name: "Portugal",            dial: "+351" },
  { code: "GR", flag: "🇬🇷", name: "Greece",              dial: "+30"  },
  { code: "PL", flag: "🇵🇱", name: "Poland",              dial: "+48"  },
  { code: "SE", flag: "🇸🇪", name: "Sweden",              dial: "+46"  },
  { code: "NO", flag: "🇳🇴", name: "Norway",              dial: "+47"  },
  { code: "DK", flag: "🇩🇰", name: "Denmark",             dial: "+45"  },
  { code: "FI", flag: "🇫🇮", name: "Finland",             dial: "+358" },
  { code: "CZ", flag: "🇨🇿", name: "Czech Republic",      dial: "+420" },
  { code: "HU", flag: "🇭🇺", name: "Hungary",             dial: "+36"  },
  { code: "RO", flag: "🇷🇴", name: "Romania",             dial: "+40"  },
  { code: "IE", flag: "🇮🇪", name: "Ireland",             dial: "+353" },
  { code: "IS", flag: "🇮🇸", name: "Iceland",             dial: "+354" },
  { code: "EE", flag: "🇪🇪", name: "Estonia",             dial: "+372" },
  { code: "LV", flag: "🇱🇻", name: "Latvia",              dial: "+371" },
  { code: "LT", flag: "🇱🇹", name: "Lithuania",           dial: "+370" },
  { code: "LU", flag: "🇱🇺", name: "Luxembourg",          dial: "+352" },
  { code: "MT", flag: "🇲🇹", name: "Malta",               dial: "+356" },
  { code: "SI", flag: "🇸🇮", name: "Slovenia",            dial: "+386" },
  { code: "SK", flag: "🇸🇰", name: "Slovakia",            dial: "+421" },
  { code: "LI", flag: "🇱🇮", name: "Liechtenstein",       dial: "+423" },
  { code: "GB", flag: "🇬🇧", name: "United Kingdom",      dial: "+44"  },
  // North America
  { code: "US", flag: "🇺🇸", name: "United States",       dial: "+1"   },
  { code: "CA", flag: "🇨🇦", name: "Canada",              dial: "+1"   },
  // Asia / Africa popular
  { code: "IN", flag: "🇮🇳", name: "India",               dial: "+91"  },
  { code: "PK", flag: "🇵🇰", name: "Pakistan",            dial: "+92"  },
  { code: "BD", flag: "🇧🇩", name: "Bangladesh",          dial: "+880" },
  { code: "PH", flag: "🇵🇭", name: "Philippines",         dial: "+63"  },
  { code: "ID", flag: "🇮🇩", name: "Indonesia",           dial: "+62"  },
  { code: "MY", flag: "🇲🇾", name: "Malaysia",            dial: "+60"  },
  { code: "TH", flag: "🇹🇭", name: "Thailand",            dial: "+66"  },
  { code: "VN", flag: "🇻🇳", name: "Vietnam",             dial: "+84"  },
  { code: "CN", flag: "🇨🇳", name: "China",               dial: "+86"  },
  { code: "JP", flag: "🇯🇵", name: "Japan",               dial: "+81"  },
  { code: "KR", flag: "🇰🇷", name: "South Korea",         dial: "+82"  },
  { code: "RU", flag: "🇷🇺", name: "Russia",              dial: "+7"   },
  { code: "ZA", flag: "🇿🇦", name: "South Africa",        dial: "+27"  },
  { code: "NG", flag: "🇳🇬", name: "Nigeria",             dial: "+234" },
  { code: "KE", flag: "🇰🇪", name: "Kenya",               dial: "+254" },
  { code: "AU", flag: "🇦🇺", name: "Australia",           dial: "+61"  },
  { code: "NZ", flag: "🇳🇿", name: "New Zealand",         dial: "+64"  },
  { code: "BR", flag: "🇧🇷", name: "Brazil",              dial: "+55"  },
  { code: "MX", flag: "🇲🇽", name: "Mexico",              dial: "+52"  },
];

export const DEFAULT_DIAL = "+966";

// Dial codes sorted by length desc so we match longest prefix first ("+971" before "+9")
const DIALS_SORTED = [...new Set(PHONE_COUNTRIES.map((c) => c.dial))]
  .sort((a, b) => b.length - a.length);

/** Parse a stored phone string into { dial, local }. Defaults to +966 when no prefix. */
export function parsePhone(raw) {
  const s = String(raw || "").trim();
  if (!s) return { dial: DEFAULT_DIAL, local: "" };
  // Normalize leading 00 → +
  const normalized = s.startsWith("00") ? "+" + s.slice(2) : s;
  if (normalized.startsWith("+")) {
    for (const d of DIALS_SORTED) {
      if (normalized.startsWith(d)) {
        const local = normalized.slice(d.length).replace(/^\s+/, "");
        return { dial: d, local: local.replace(/[^0-9]/g, "") };
      }
    }
    // Unknown prefix — keep whole digits as local
    return { dial: DEFAULT_DIAL, local: normalized.replace(/[^0-9]/g, "") };
  }
  return { dial: DEFAULT_DIAL, local: normalized.replace(/[^0-9]/g, "") };
}

/** Join { dial, local } back into stored format e.g. "+966 555123456". */
export function formatPhone(dial, local) {
  const l = String(local || "").replace(/[^0-9]/g, "");
  if (!l) return "";
  return `${dial} ${l}`;
}
